export const ADD_PRELOADED_IMAGE = 'ADD_PRELOADED_IMAGE'
export const ADD_PRELOADED_IMAGES = 'ADD_PRELOADED_IMAGES'
